/**
 * Returns the current path from the browser URL (pathname or hash).
 * Use when the Angular router may not have synced yet (e.g. initial load on /error).
 */
export function getPathFromBrowser(): string {
  const loc = (typeof globalThis !== 'undefined' && (globalThis as any).location) || null;
  if (!loc) return '';
  const hash = typeof loc.hash === 'string' ? loc.hash : '';
  if (hash.startsWith('#') && hash.length > 1) {
    const pathAndQuery = hash.slice(1).split('?')[0];
    return pathAndQuery || '/';
  }
  const pathname = typeof loc.pathname === 'string' ? loc.pathname : '';
  return pathname || '/';
}

/** True if the current browser path is the error page. */
export function isErrorPath(path: string): boolean {
  return path === '/error' || path.endsWith('/error');
}